<template lang="pug">
  div
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title(style="height:56px;")
          v-layout
            h6.basic800--text {{ $t('business_hours') }}
            v-spacer
            v-btn.my-auto.ml-2(small color="textColorAccent" outlined height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="clickAddOption")
              eva-icon.ml-n2.mt-1(name="plus-outline" height="14" width="14" :fill="$vuetify.theme.themes[$theme].textColorAccent")
              .button-AA-tiny.textColorAccent--text add new
        v-divider.basic300

        v-card-text.pa-0
          v-container
            v-layout.my-6(v-if="isFetching")
                v-row.fill-height.ma-0(align='center' justify='center')
                  v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            .content-layout(v-else)
              v-row.fill-height.ma-0(align='center' justify='center' v-if="options.length == 0")
                div.mx-auto.text-center
                  v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                  p.caption No options added yet
              v-simple-table.mb-2(v-else dense)
                thead
                  tr
                    th Description
                    th Start
                    th End
                    th.text-center Action
                tbody
                  tr(v-for="(option, index) in options" :key="option.id")
                    td
                      div {{ option.name }}
                    td
                      div {{ formatTime(option.start_time) }}
                    td
                      div {{ formatTime(option.end_time) }}
                    td.text-center
                      div
                        v-btn(icon @click="clickDeleteOption(option)")
                          v-icon(color="grey") mdi-delete-outline
                        v-btn(icon @click="clickEditOption(option)")
                          v-icon mdi-square-edit-outline
        v-card-actions
          v-spacer
          v-btn(color='grey', text @click='showModal = false')
            .button-Aa-medium.textColorAccent--text {{ $t('close') }}

    .modals
      update-tenant-business-hours(v-if="showUpdateOptionDialog" :open.sync="showUpdateOptionDialog" :settings="settings" :option="editingOption" @added="handleAddItem" @edited="handleEditItem")
      y-dialog(v-model='showDeleteOptionDialog', max-width='290')
        v-card
          v-card-title.title Delete Option
          v-card-text
            | Are you sure you want to delete this option? This option will be deleted permanently.
          v-card-actions
            v-spacer
            v-btn(color='grey', text='', @click='showDeleteOptionDialog = false')
              | Cancel
            v-btn(color='red', text='', @click='startDelete' :loading="isLoading")
              | Delete

</template>

<script>
import { mapActions } from 'vuex'
import UpdateTenantBusinessHours from '@/components/dialogs/UpdateTenantBusinessHours.vue'
export default {
  name: 'TenantBusinessHours',
  components: { UpdateTenantBusinessHours },
  props: ['open', 'settings', 'company'],
  data: () => ({
    isFetching: true,
    showUpdateOptionDialog: false,
    showDeleteOptionDialog: false,
    editingOption: null,
    deleteOption: null,
    options: [],
    isLoading: false
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.isFetching = true
    this.fetchOptions()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    formatTime (time24) {
      let ts = time24
      const H = + ts.substr(0, 2)
      let h = (H % 12) || 12
      h = (h < 10) ? ('0' + h) : h
      const ampm = H < 12 ? 'AM' : 'PM'
      ts = h + ':' + ts.substr(3, 2) + ampm
      return ts
    },
    fetchOptions () {
      this.$axios.get(`/malls/${this.settings.mall.id}/branches/${this.settings.branch.id}/tenants/${this.company.slug}/business_hours`)
        .then((response) => {
          this.options = response.data.results
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    clickAddOption () {
      this.editingOption = null
      this.showUpdateOptionDialog = true
    },
    clickEditOption (option) {
      this.editingOption = option
      this.showUpdateOptionDialog = true
    },
    startDelete() {
      this.isLoading  = true
      this.$axios.delete(`/malls/${this.settings.mall.id}/branches/${this.settings.branch.id}/tenants/${this.company.slug}/business_hours/${this.deleteOption.id}/`)
        .then(() => {
          this.options = this.options.filter((x) => x !== this.deleteOption)
          this.showDeleteOptionDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading  = false
        })
    },
    clickDeleteOption(option) {
      this.showDeleteOptionDialog = true
      this.deleteOption = option
    },
    handleAddItem (item) {
      this.options.push(item)
      this.$emit('activated', item)
    },
    handleEditItem (item) {
      for (var i = 0; i < this.options.length; i++) {
        let option = this.options[i]
        if (option.id === item.id) {
          this.options[i] = item
        }
      }
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "business_hours": "Business Hours"
  }
}
</i18n>
